import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const TabPlaceholder = ({ title }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: "360px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Typography
        sx={{
          color: theme.palette.primary.greyPrimary,
          fontFamily: theme.typography.fontFamily,
          fontSize: theme.typography.customFontSize[3],
          fontWeight: theme.typography.customFontWeight[2],
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};

export default TabPlaceholder;
